import { Group } from '@mantine/core';
import { Button, Text } from '@repo/foundations';
import { useCallback } from 'react';
import type { TopLevelOperatorType } from './types';

interface TopLevelOperatorToggleProps {
	value: TopLevelOperatorType;
	onChange: (value: TopLevelOperatorType) => void;
	toggleLabel?: string;
	readOnly?: boolean;
}

export function TopLevelOperatorToggle({
	value,
	onChange,
	toggleLabel = 'filters',
	readOnly = false,
}: TopLevelOperatorToggleProps) {
	const onClick = useCallback(() => {
		onChange(value === 'and' ? 'or' : 'and');
	}, [onChange, value]);

	return (
		<Group spacing={0} noWrap align="baseline">
			<Text color="text/secondary/default" size="xs">
				Match
			</Text>
			<Button
				disabled={readOnly}
				onClick={onClick}
				variant="tertiary"
				size="sm"
				data-testid="filter-rule-toggle"
			>
				{value === 'and' ? 'All' : 'Any'} {toggleLabel}
			</Button>
		</Group>
	);
}
